import {CheckCircle} from 'lucide-react';
import SectionTitle from '../common/SectionTitle';
const Specifications = () => {
  const specs = [
    'Premium residential township inspired by classical and neoclassical architecture',
    'Grand entrance gate with arches, floral murals, sculptures, and landscaped boulevards',
    'Well-planned internal road network with ornamental street lighting',
    'Lush green landscaping with flowering trees, gardens, and water features',
    'Gated township with controlled access for safety and privacy',
    'Thoughtfully planned infrastructure designed for long-term sustainability',
    'Harmonious blend of architecture, greenery, fragrance, and open spaces',
    'Peaceful, low-density living environment with focus on lifestyle and wellness'
  ];

  return (
    <section className="py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle 
          title="Project Specifications"
          subtitle="Crafted with attention to every detail"
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 mt-10 gap-6">
          {specs.map((spec, idx) => (
            <div key={idx} className="bg-gradient-to-br from-emerald-50 to-teal-50 p-6 rounded-xl shadow-md hover:shadow-xl transition-all">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <CheckCircle className="text-emerald-600" size={24} />
              </div>
              <p className="text-gray-700 leading-relaxed">{spec}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Specifications;
